<template>
  <p class="subtitle">
    רק מספר הרישוי של הרכב המוצע למכירה, אנחנו כבר נמצא הכל.
  </p>
  <form @submit="search">
    <div class="form-field center">
      <label for="carNumber">מספר רישוי</label>
      <input name="carNumber" type="tel" minlength="7" maxlength="8" v-model="carNumber" required />
    </div>
    <div class="form-actions">
      <button type="button" @click="goBack()">חזרה</button>
      <button type="submit" :disabled="!carNumberIsValid">המשך</button>
    </div>
  </form>
</template>
<script>
export default {
  name: "LocateVehicle",
  data() {
    return {
      carNumber: ""
    };
  },
	computed: {
		carNumberIsValid() {
			return this.carNumber.length >= 7 && this.carNumber.length <= 8
			/*return this.carNumber.match(
					/^([0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{2}-[0-9]{3}-[0-9]{2})$/
			);*/
		}
	},
  methods: {
    goBack() {
      this.$router.push({
				name: 'agents-area'
			});
    },
    search() {
      this.$router.push({
				name: 'car',
				params: {
					id: this.carNumber
				}
			});
    },
  },
};
</script>
